import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../../utils/themes/ThemeProvider'

type Props = {
  width?: number | string
  height?: number | string
}

export const NicotineQuitlineBenefitIllustration: FunctionComponent<Props> = ({ width = 66, height = 65 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { benefitIllustration } = colors.icons
  return (
    <Svg width={width} height={height} viewBox='0 0 66 65' fill='none'>
      <Path
        d='M55.6416 31.1907V36.7219C55.6416 37.4098 54.879 37.9688 53.9385 37.9688H12.5156C11.5737 37.9688 10.8125 37.4098 10.8125 36.7219V31.1907C10.8125 30.5014 11.5751 29.9438 12.5156 29.9438H53.9385C54.8804 29.9438 55.6416 30.5014 55.6416 31.1907Z'
        fill={benefitIllustration.primary.fill}
      />
      <Path
        d='M55.6456 31.1907V36.7219C55.6456 37.4098 54.883 37.9688 53.9425 37.9688H50.9248V29.9438H53.9425C54.8844 29.9438 55.6456 30.5014 55.6456 31.1907Z'
        fill={benefitIllustration.secondary.fill}
      />
      <Path
        d='M34.648 12.3718C34.1401 14.1623 34.0675 16.1587 34.5129 17.6858C34.9041 19.0294 35.6895 20.4149 37.2588 20.8156C40.5597 21.659 43.586 20.747 46.8513 22.1956C50.1165 23.6442 50.4979 26.7783 50.4979 26.7783C50.4979 26.7783 53.655 19.2773 49.5588 17.068C45.4626 14.8586 40.675 16.6393 39.4542 14.2702C38.7499 12.9028 37.9887 10.8405 37.4467 10.3054C35.9129 8.78948 34.648 12.3718 34.648 12.3718Z'
        fill={benefitIllustration.primary.fill}
      />
      <Path
        d='M43.6266 54.4745C42.8213 54.4745 42.0444 54.0388 41.656 53.2808L22.8369 16.5887C22.2877 15.5184 22.7245 14.2126 23.8115 13.6718C24.8985 13.1311 26.2245 13.5612 26.7737 14.6315L45.5929 51.3236C46.1421 52.394 45.7053 53.6997 44.6183 54.2405C44.2996 54.3988 43.9595 54.4745 43.6266 54.4745Z'
        fill={benefitIllustration.secondary.fill}
      />
    </Svg>
  )
}
